import { render, staticRenderFns } from "./AppartmentDetails.vue?vue&type=template&id=4f8b954a&"
import script from "./AppartmentDetails.vue?vue&type=script&lang=ts&"
export * from "./AppartmentDetails.vue?vue&type=script&lang=ts&"
import style0 from "./AppartmentDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AppartmentDetails.vue"
export default component.exports